import { getParams } from '../../utils';
export const getDicomstat = data => {
  const search = getParams(data);
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  };

  let url = `/ai-web/fromDr/dicomstat?${search}`;

  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

// 获取医生审核字典数据
export const getDoctorConfigs = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/getDoctorConfigs`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//数据看板接口1(可以修改日期部分)
export const boardOtherData = (data = {}) => {
  const search = getParams(data);
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/boardOtherData?${search}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//数据看板接口2(今日实时数据部分)
export const boardTodayData = (data = {}) => {
  const search = getParams(data);
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/boardTodayData?${search}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//数据看板接口3（近7日AI诊断人数部分）
export const boardXdaysData = (data = {}) => {
  const search = getParams(data);
  const init = { method: 'GET' };
  return fetch(`/ai-web/fromDr/boardXdaysData?${search}`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//查询"检查部位"的字典项
export const bodyPart = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/bodyPart`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//查询机构项目列表
export const instProjectInfo = (page, size) => {
  const init = { method: 'GET' };
  let url = `/ai-web/fromDr/instProjectInfo`;
  if (page && size) url += `?pageNum=${page}&pageSize=${size}`;
  return fetch(url, init).then(res => res.json(), err => console.error(err));
};

//修改项目
export const modifyInstProject = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/modifyInstProject`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//新增项目名称
export const addInstProject = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/fromDr/addInstProject`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//是否接入牛盒的开关查数据字典
export const openNboxAIResult = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/sysConfig/OPEN_NBOX_AI_RESULT`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//
export const sysConfig = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/sysConfig`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//民族字典
export const national = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/national`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//证件类型
export const IDType = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/IDType`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};

//就诊卡类型字典
export const cardType = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/cardType`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
